// extracted by mini-css-extract-plugin
module.exports = {"chatWidget":"_1z51f","mobile":"MiTII","expanded":"_3VdXB","left":"g6HOG","minimizedChat":"kMF93","right":"_1QctC","fixed":"_206Cl"};